
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91id_932170OYj8djtGJ7rt4NJ32_8JZolILymVwBZEdbGRLiUMeta } from "/tmp/build_68735d90/pages/Cases/Overview/[id].vue?macro=true";
import { default as _91id_93M1b9OhJ2pxhQ6EIAE2gQFPigbcK6PK75jq8kPinVcocMeta } from "/tmp/build_68735d90/pages/Service Requests/Overview/[id].vue?macro=true";
import { default as indexXFg4Su4S0fOzcSQT_cKq_Ct_VTRs5oEfHqfMXSq73CQMeta } from "/tmp/build_68735d90/pages/Cases/Overview/index.vue?macro=true";
import { default as _91id_93G6ooBGQX6NRitlRj_MQMEWfR_jZXpOiOsNIWWhup9rsMeta } from "/tmp/build_68735d90/pages/Companies/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93zSCOQREFK3kJMIVwSsw77SVLG9_zavIUGWWJusIFRLkMeta } from "/tmp/build_68735d90/pages/Companies/Overview/Operations/[id].vue?macro=true";
import { default as _91id_93c19ELF2_RaLuI9Qv5nQ0Onq2gE34xgWX5SIHXcwH_IwMeta } from "/tmp/build_68735d90/pages/Companies/Overview/Sales/[id].vue?macro=true";
import { default as indexZt6e82yvu_k8PLjCyzHT9yCuxUO64GWEArcghleyZ28Meta } from "/tmp/build_68735d90/pages/Companies/Overview/Activities/index.vue?macro=true";
import { default as indexq7CQD3Zv25_hbEmayiKAACz7GaBQyH6gtpULH_xShmQMeta } from "/tmp/build_68735d90/pages/Companies/Overview/Operations/index.vue?macro=true";
import { default as indexQaeRGmdsBsYf7fliMoLqbrGES9g3TiiiA_XAdt7ZZyMMeta } from "/tmp/build_68735d90/pages/Companies/Overview/Sales/index.vue?macro=true";
import { default as Overviewi5qDuMgU4GuxCQbkRZvklGrMYSTXU7iUbMY1ujr0N6kMeta } from "/tmp/build_68735d90/pages/Companies/Overview.vue?macro=true";
import { default as _91id_93EAHz1uEYj_mgZKFKtrTK7c7nhV_6JphGM8trziFk6i0Meta } from "/tmp/build_68735d90/pages/Home/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93_cIx_A0SroEd4bWIDqCjZOvjQWiP1TFAfsE62LL9YJQMeta } from "/tmp/build_68735d90/pages/Home/Overview/Operations/[id].vue?macro=true";
import { default as _91id_93Ox4PyzT2CBCwG9vsCIIJiC1er3wuQfKo1UxKGxUaPkIMeta } from "/tmp/build_68735d90/pages/Home/Overview/Sales/[id].vue?macro=true";
import { default as _91id_93yxyLnoWg6ZCxbP8Jp_wxzWzwEQVpa4PXdkA1FFB6bI4Meta } from "/tmp/build_68735d90/pages/Home/Overview/Splits/[id].vue?macro=true";
import { default as indexWxgj1nzem3g0kXHw_qh0dm8krTK4hNc5nev_IokA0tQMeta } from "/tmp/build_68735d90/pages/Home/Overview/Activities/index.vue?macro=true";
import { default as indexaS0i3qwcfKqtTZVqPAmD16hUqVDD3ZLSo0WOhGnTybgMeta } from "/tmp/build_68735d90/pages/Home/Overview/Operations/index.vue?macro=true";
import { default as indexLqAQDaK3S8I_9CrLMXoL83sQ_1EzZ6SGsv1h6uPG0qsMeta } from "/tmp/build_68735d90/pages/Home/Overview/Sales/index.vue?macro=true";
import { default as indexzs37xP5BNwr95WY7WlkmX0otaF3JunurIFoUflO6tyoMeta } from "/tmp/build_68735d90/pages/Home/Overview/Splits/index.vue?macro=true";
import { default as OverviewZWnBG3vFqDV4OjYDxnIKiFL_0Vtx64cyOdRxSDsUJBcMeta } from "/tmp/build_68735d90/pages/Home/Overview.vue?macro=true";
import { default as _91id_93AMMCebfYtwg19DD3ivRvwBc7V3z9JUYBoBYdSXwvfGsMeta } from "/tmp/build_68735d90/pages/Opportunities/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93fBOfHyviNViIYbUAiNF_6o3HOQWcvIax5jpCVAWqqD0Meta } from "/tmp/build_68735d90/pages/Opportunities/Overview/Operations/[id].vue?macro=true";
import { default as _91id_93h_FJBCN7zLs_Rkj3geE5CxBENVPFnF6UBKoDJOEiqU0Meta } from "/tmp/build_68735d90/pages/Opportunities/Overview/Sales/[id].vue?macro=true";
import { default as indexDNvI9j_nqK8mdMVavbYYsQfGPQlFRmxXy3DwPLnST6kMeta } from "/tmp/build_68735d90/pages/Opportunities/Overview/Activities/index.vue?macro=true";
import { default as indexy7NjberBjvOd_1YtdJbapyOtFJFox3MWtybhDbbNeLsMeta } from "/tmp/build_68735d90/pages/Opportunities/Overview/Operations/index.vue?macro=true";
import { default as indexTrc42JHEvZiGzyRlc0tes66sbQFcZXbo7QbKEkQWjVYMeta } from "/tmp/build_68735d90/pages/Opportunities/Overview/Sales/index.vue?macro=true";
import { default as OverviewLHSXReoyUfOoHODid8Ps8OpeFU_o2gwBZcyKHRqCNwwMeta } from "/tmp/build_68735d90/pages/Opportunities/Overview.vue?macro=true";
import { default as _91id_933RhtRq63QTQYGQtyrXMHL5pMIddt6gUWT4lQJOy3i00Meta } from "/tmp/build_68735d90/pages/Orders/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93zi2yYEyt6_RGCZ2NTA1qldH_VvOa_T_8l5Cq8qJHk1YMeta } from "/tmp/build_68735d90/pages/Orders/Overview/Sales/[id].vue?macro=true";
import { default as indexb3442G6w9nTXsRj61ka_XMFkvlEWxGmfXIYiPHFwgE0Meta } from "/tmp/build_68735d90/pages/Orders/Overview/Activities/index.vue?macro=true";
import { default as index4kX1w3CNZ6bIHT0mrfcXzcp_uf5MYtqtgUJMN1Y1tXYMeta } from "/tmp/build_68735d90/pages/Orders/Overview/Sales/index.vue?macro=true";
import { default as OverviewJp0lIFw8vRSBOXg9EC870_kMVAYBNl7iNkI_ukuekYoMeta } from "/tmp/build_68735d90/pages/Orders/Overview.vue?macro=true";
import { default as indexO_fwqS_mjfyIfys6L2_Ym4RikdlKWfqGv9L_M__jWWgMeta } from "/tmp/build_68735d90/pages/Service Requests/Overview/index.vue?macro=true";
import { default as _91id_93MQ5xvwViTpiJUBJlE2cDXNvi2jTOqPnaQ5KI6aU8zJAMeta } from "/tmp/build_68735d90/pages/Suppliers/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93NwGOZD5_0JWNs1hK2DnszaYwh1KnzMhERcT0m0cNzW8Meta } from "/tmp/build_68735d90/pages/Suppliers/Overview/Sales/[id].vue?macro=true";
import { default as index_WOsKLLL9OgNapfMZTQeKr_KNfT8yWV8Oe_oiqQJWPMMeta } from "/tmp/build_68735d90/pages/Suppliers/Overview/Activities/index.vue?macro=true";
import { default as indexlRdZQpsohYE8fwl_gkHitB_E_6Wm6OCYACkxIJUAMUwMeta } from "/tmp/build_68735d90/pages/Suppliers/Overview/Sales/index.vue?macro=true";
import { default as OverviewV_PDd4IDJaap8TkMv3ci1uUQybl3yQZOJ_03CKBNo2kMeta } from "/tmp/build_68735d90/pages/Suppliers/Overview.vue?macro=true";
import { default as _91id_93bZ_pNgWYEDElg4D6tX8ikD9RnEpVFyJfVfdpSbpAl3QMeta } from "/tmp/build_68735d90/pages/Accounts/[id].vue?macro=true";
import { default as _91id_93EKQ5du06WCknvfFqpbccqQBQ17p3mkWmPuyI9BcUsh0Meta } from "/tmp/build_68735d90/pages/Field Sets/[id].vue?macro=true";
import { default as _91id_93iMo8a31XIG7agABbn939sTxGltp4Zgu2dKSxV1G9REEMeta } from "/tmp/build_68735d90/pages/Industries/[id].vue?macro=true";
import { default as _91id_9336z2QWhlJhmC5upl7PbN21Ye5p0GUq_UOtq04OKJGAQMeta } from "/tmp/build_68735d90/pages/Locations/[id].vue?macro=true";
import { default as _91id_93hbNauNINCZTt4JpaRgO6jtUBPtO3Jc5nma_3yzLBew8Meta } from "/tmp/build_68735d90/pages/Product Categories/[id].vue?macro=true";
import { default as _91id_93npb5TRpIu68zzRLEkp4of9N6Wd6D8pj__foURYwj1dYMeta } from "/tmp/build_68735d90/pages/Product Groups/[id].vue?macro=true";
import { default as _91id_93s7FVOa9wXTW38PUOHTZ0_bkgC0PAkRmtJr8GbaW3iDUMeta } from "/tmp/build_68735d90/pages/Product Subcategories/[id].vue?macro=true";
import { default as _91id_93J6MzDzlJnsoxpCeE_Bx0ViUU9Ytu_vUXPpVsfWAppw8Meta } from "/tmp/build_68735d90/pages/Products/[id].vue?macro=true";
import { default as _91id_93MEhKFqnCoXfki_nPs2MVAR_pezUHygOJRmMSaW7hIIgMeta } from "/tmp/build_68735d90/pages/Projects/[id].vue?macro=true";
import { default as _91id_93k2mf4rQXjRbvl7T_KAxP43K836OPAeCJXulEhbddhvUMeta } from "/tmp/build_68735d90/pages/SupplierProducts/[id].vue?macro=true";
import { default as _91id_93jpCh4tHgXdnY8zghEgMEIE3G0DiHIJC78LF0HC6mfdYMeta } from "/tmp/build_68735d90/pages/Team Members/[id].vue?macro=true";
import { default as _91id_938FNd5VtqvAJWFUr7KVKbPEA6UNRpYY8fIeN5fcyvn9EMeta } from "/tmp/build_68735d90/pages/TSDs/[id].vue?macro=true";
import { default as indexXNUVexaNnDB7MDD5zSOAe41W1_JG6nNq_3it0yjDgUkMeta } from "/tmp/build_68735d90/pages/Accounts/index.vue?macro=true";
import { default as indexmhKi1lODoNvvM1Xxm6p9Sj65_SiD1KBvuLCAkpY47v8Meta } from "/tmp/build_68735d90/pages/Case Types/index.vue?macro=true";
import { default as indexu2unkywC6oxbYpaQB7R2QHNwI_VMEUZFLtpm_6bYM8QMeta } from "/tmp/build_68735d90/pages/Cases/index.vue?macro=true";
import { default as indexsYFZGNG1AhaXlBwGUrNRNPXQOvqSuXf_TDVH_CflAYAMeta } from "/tmp/build_68735d90/pages/Companies/index.vue?macro=true";
import { default as indexJJO4_VpZrOmCPjt1HbyTujwxJpvnFwGwQrrd2XpqngUMeta } from "/tmp/build_68735d90/pages/Company Contact Roles/index.vue?macro=true";
import { default as indexwxD8QZ_oG4C9Gjrd3RruGQVWLMZabrYB734dE_Uj44sMeta } from "/tmp/build_68735d90/pages/Contacts/index.vue?macro=true";
import { default as indexpvZXz_7YJtAFh70o0p728LFdXYH4RfX41ndSA_Vf2zEMeta } from "/tmp/build_68735d90/pages/Dashboard/index.vue?macro=true";
import { default as indexKTyoTB86ebUOf0yKcPxCe3B_kp3R0fexQQKzZl15SsoMeta } from "/tmp/build_68735d90/pages/Field Sets/index.vue?macro=true";
import { default as indexR3SpWmbhXDNplq73EY44xF26vMpqGuwV6knedASljoUMeta } from "/tmp/build_68735d90/pages/Groups/index.vue?macro=true";
import { default as index3KffL6CCEepeoBWinflgThGFp7TTHe88xNqiJ5OCigYMeta } from "/tmp/build_68735d90/pages/Home/index.vue?macro=true";
import { default as index7akPLFGl7TGDmCr3U_1KqSqnitjvVTRDM5i_VKuTeIsMeta } from "/tmp/build_68735d90/pages/Industries/index.vue?macro=true";
import { default as indexK_r_C0w9UVFiWN7EZn9RaLZtlJerRTZk_AMRLTCqlK8Meta } from "/tmp/build_68735d90/pages/Lead Source Campaigns/index.vue?macro=true";
import { default as indexAtG4t2f4_itlTEHt5jJe5Thki1mSVKZ5CGI_ObPjqUkMeta } from "/tmp/build_68735d90/pages/Lead Source Contacts/index.vue?macro=true";
import { default as indextvfxHvBQbkDm6je34U1DINgU0nAgFapK0ddwM_zvJr0Meta } from "/tmp/build_68735d90/pages/Lead Source Events/index.vue?macro=true";
import { default as indexwvsGGKRa96KknFNbOGILoIA8QcUAkEgxr90C7WRM5iIMeta } from "/tmp/build_68735d90/pages/Location Types/index.vue?macro=true";
import { default as indexgewO2KykTTt6qoAouWm9rktTHSdPhSI9gE0YS9gls8AMeta } from "/tmp/build_68735d90/pages/Login/index.vue?macro=true";
import { default as index04CxddAvT1kTH5EL91piW_1tqIoWdt8LeJl_qu6fkJMMeta } from "/tmp/build_68735d90/pages/Opportunities/index.vue?macro=true";
import { default as index3ARA6qUJlZzAFRuioK6ccAE7gy0nOmxU2WJW3kyWmegMeta } from "/tmp/build_68735d90/pages/Opportunity Stages/index.vue?macro=true";
import { default as indexV0XL1HcYJnj4U6WokXvhhrW1DMK9ELLbD9tweiIbsjUMeta } from "/tmp/build_68735d90/pages/Orders/index.vue?macro=true";
import { default as indexoVhodoixe1ymzS6SMmeK_bPzZrYtfWCdU_VR_R42sS4Meta } from "/tmp/build_68735d90/pages/Payables/index.vue?macro=true";
import { default as indexid9GJgCvRNoR7iGBUBfq7L6hPW4MMLrR9aJptu4carsMeta } from "/tmp/build_68735d90/pages/Persons/index.vue?macro=true";
import { default as indexPaceUs3_Vq7ZXuqvKrO2Gcu8pxeMBY2Au16i3M_C2aMMeta } from "/tmp/build_68735d90/pages/Product Categories/index.vue?macro=true";
import { default as indexJoeVYd21zMvi7_tJSV01MCUFlB7KbSRFIluTYwd06bgMeta } from "/tmp/build_68735d90/pages/Product Groups/index.vue?macro=true";
import { default as indexYg1X999W0CsyEvnNO3G87ISzssFZHO09i_JvJoWqGloMeta } from "/tmp/build_68735d90/pages/Product Subcategories/index.vue?macro=true";
import { default as indexue2IOo0JW_oCyrkZBb2g_YyNzlXLkoclmajPzfZd9KYMeta } from "/tmp/build_68735d90/pages/Projects/index.vue?macro=true";
import { default as indexj6UyBQ8Z9vWtGQA_CIDyqYcXzXQvy5S_6T2_Dz_IdoMMeta } from "/tmp/build_68735d90/pages/Receivables/index.vue?macro=true";
import { default as indexkAaFk2RF30Zh29minqQeIbZ6Z6JVcqVOw5hlnYHzLt4Meta } from "/tmp/build_68735d90/pages/Service Request Types/index.vue?macro=true";
import { default as indexKjHziAU7qbA5wLaauovEjtvrmORWwuGPTvLvouhtz00Meta } from "/tmp/build_68735d90/pages/Service Requests/index.vue?macro=true";
import { default as indexOIUz_DPTC0IssqNTwEgcIF6qB14P9AUpkPlUhjy1a34Meta } from "/tmp/build_68735d90/pages/Settings/index.vue?macro=true";
import { default as indexdE96fT3UpB6exc576TRh_gmodQtLzmEVAOIP09o51yMMeta } from "/tmp/build_68735d90/pages/Supplier Contact Roles/index.vue?macro=true";
import { default as indexR0z_vLvErthXQAAECqu_Ge97uaDE0vOu3J77rNpdgcAMeta } from "/tmp/build_68735d90/pages/Suppliers/index.vue?macro=true";
import { default as indexhHMyJr0_FIoABnm_UFuYsV5Uw3EwZ8wKPBsFImytqp0Meta } from "/tmp/build_68735d90/pages/Team Members/index.vue?macro=true";
import { default as indexulTwraHAIJ06lx1R7e_ys1oqNnmA_4UqqsZa3wiXnhIMeta } from "/tmp/build_68735d90/pages/TSD Contact Roles/index.vue?macro=true";
import { default as indexdi1uwXvAWM6hznQetkBd7C5wPtXAQZ5xcPT2B8oywQcMeta } from "/tmp/build_68735d90/pages/TSDs/index.vue?macro=true";
import { default as indexwWwVcqdreyYOoVZiuX8LGpBJ2NKjUJz8W3ut9_UODrYMeta } from "/tmp/build_68735d90/pages/User/index.vue?macro=true";
import { default as indexn4ZoD2GdDg7fV_qMXU35IavblTeaHi2xk9V5v9Oeep4Meta } from "/tmp/build_68735d90/pages/Users/index.vue?macro=true";
import { default as index4cXT8f8887Y3pSPupqZtZodxzqTMJtHcUumV3RJP3AQMeta } from "/tmp/build_68735d90/pages/index.vue?macro=true";
export default [
  {
    name: "Cases-Overview-id",
    path: "/Cases/Overview/:id()",
    component: () => import("/tmp/build_68735d90/pages/Cases/Overview/[id].vue")
  },
  {
    name: "Service Requests-Overview-id",
    path: "/Service%20Requests/Overview/:id()",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_68735d90/pages/Service Requests/Overview/[id].vue")
  },
  {
    name: "Cases-Overview",
    path: "/Cases/Overview",
    component: () => import("/tmp/build_68735d90/pages/Cases/Overview/index.vue")
  },
  {
    name: "Companies-Overview",
    path: "/Companies/Overview",
    component: () => import("/tmp/build_68735d90/pages/Companies/Overview.vue"),
    children: [
  {
    name: "Companies-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_68735d90/pages/Companies/Overview/Activities/[id].vue")
  },
  {
    name: "Companies-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_68735d90/pages/Companies/Overview/Operations/[id].vue")
  },
  {
    name: "Companies-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_68735d90/pages/Companies/Overview/Sales/[id].vue")
  },
  {
    name: "Companies-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_68735d90/pages/Companies/Overview/Activities/index.vue")
  },
  {
    name: "Companies-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_68735d90/pages/Companies/Overview/Operations/index.vue")
  },
  {
    name: "Companies-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_68735d90/pages/Companies/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Home-Overview",
    path: "/Home/Overview",
    component: () => import("/tmp/build_68735d90/pages/Home/Overview.vue"),
    children: [
  {
    name: "Home-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_68735d90/pages/Home/Overview/Activities/[id].vue")
  },
  {
    name: "Home-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_68735d90/pages/Home/Overview/Operations/[id].vue")
  },
  {
    name: "Home-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_68735d90/pages/Home/Overview/Sales/[id].vue")
  },
  {
    name: "Home-Overview-Splits-id",
    path: "Splits/:id()",
    component: () => import("/tmp/build_68735d90/pages/Home/Overview/Splits/[id].vue")
  },
  {
    name: "Home-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_68735d90/pages/Home/Overview/Activities/index.vue")
  },
  {
    name: "Home-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_68735d90/pages/Home/Overview/Operations/index.vue")
  },
  {
    name: "Home-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_68735d90/pages/Home/Overview/Sales/index.vue")
  },
  {
    name: "Home-Overview-Splits",
    path: "Splits",
    component: () => import("/tmp/build_68735d90/pages/Home/Overview/Splits/index.vue")
  }
]
  },
  {
    name: "Opportunities-Overview",
    path: "/Opportunities/Overview",
    component: () => import("/tmp/build_68735d90/pages/Opportunities/Overview.vue"),
    children: [
  {
    name: "Opportunities-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_68735d90/pages/Opportunities/Overview/Activities/[id].vue")
  },
  {
    name: "Opportunities-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_68735d90/pages/Opportunities/Overview/Operations/[id].vue")
  },
  {
    name: "Opportunities-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_68735d90/pages/Opportunities/Overview/Sales/[id].vue")
  },
  {
    name: "Opportunities-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_68735d90/pages/Opportunities/Overview/Activities/index.vue")
  },
  {
    name: "Opportunities-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_68735d90/pages/Opportunities/Overview/Operations/index.vue")
  },
  {
    name: "Opportunities-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_68735d90/pages/Opportunities/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Orders-Overview",
    path: "/Orders/Overview",
    component: () => import("/tmp/build_68735d90/pages/Orders/Overview.vue"),
    children: [
  {
    name: "Orders-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_68735d90/pages/Orders/Overview/Activities/[id].vue")
  },
  {
    name: "Orders-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_68735d90/pages/Orders/Overview/Sales/[id].vue")
  },
  {
    name: "Orders-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_68735d90/pages/Orders/Overview/Activities/index.vue")
  },
  {
    name: "Orders-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_68735d90/pages/Orders/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Service Requests-Overview",
    path: "/Service%20Requests/Overview",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_68735d90/pages/Service Requests/Overview/index.vue")
  },
  {
    name: "Suppliers-Overview",
    path: "/Suppliers/Overview",
    component: () => import("/tmp/build_68735d90/pages/Suppliers/Overview.vue"),
    children: [
  {
    name: "Suppliers-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_68735d90/pages/Suppliers/Overview/Activities/[id].vue")
  },
  {
    name: "Suppliers-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_68735d90/pages/Suppliers/Overview/Sales/[id].vue")
  },
  {
    name: "Suppliers-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_68735d90/pages/Suppliers/Overview/Activities/index.vue")
  },
  {
    name: "Suppliers-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_68735d90/pages/Suppliers/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Accounts-id",
    path: "/Accounts/:id()",
    component: () => import("/tmp/build_68735d90/pages/Accounts/[id].vue")
  },
  {
    name: "Field Sets-id",
    path: "/Field%20Sets/:id()",
    component: () => import("/tmp/build_68735d90/pages/Field Sets/[id].vue")
  },
  {
    name: "Industries-id",
    path: "/Industries/:id()",
    component: () => import("/tmp/build_68735d90/pages/Industries/[id].vue")
  },
  {
    name: "Locations-id",
    path: "/Locations/:id()",
    component: () => import("/tmp/build_68735d90/pages/Locations/[id].vue")
  },
  {
    name: "Product Categories-id",
    path: "/Product%20Categories/:id()",
    component: () => import("/tmp/build_68735d90/pages/Product Categories/[id].vue")
  },
  {
    name: "Product Groups-id",
    path: "/Product%20Groups/:id()",
    component: () => import("/tmp/build_68735d90/pages/Product Groups/[id].vue")
  },
  {
    name: "Product Subcategories-id",
    path: "/Product%20Subcategories/:id()",
    component: () => import("/tmp/build_68735d90/pages/Product Subcategories/[id].vue")
  },
  {
    name: "Products-id",
    path: "/Products/:id()",
    component: () => import("/tmp/build_68735d90/pages/Products/[id].vue")
  },
  {
    name: "Projects-id",
    path: "/Projects/:id()",
    component: () => import("/tmp/build_68735d90/pages/Projects/[id].vue")
  },
  {
    name: "SupplierProducts-id",
    path: "/SupplierProducts/:id()",
    component: () => import("/tmp/build_68735d90/pages/SupplierProducts/[id].vue")
  },
  {
    name: "Team Members-id",
    path: "/Team%20Members/:id()",
    component: () => import("/tmp/build_68735d90/pages/Team Members/[id].vue")
  },
  {
    name: "TSDs-id",
    path: "/TSDs/:id()",
    component: () => import("/tmp/build_68735d90/pages/TSDs/[id].vue")
  },
  {
    name: "Accounts",
    path: "/Accounts",
    component: () => import("/tmp/build_68735d90/pages/Accounts/index.vue")
  },
  {
    name: "Case Types",
    path: "/Case%20Types",
    component: () => import("/tmp/build_68735d90/pages/Case Types/index.vue")
  },
  {
    name: "Cases",
    path: "/Cases",
    component: () => import("/tmp/build_68735d90/pages/Cases/index.vue")
  },
  {
    name: "Companies",
    path: "/Companies",
    component: () => import("/tmp/build_68735d90/pages/Companies/index.vue")
  },
  {
    name: "Company Contact Roles",
    path: "/Company%20Contact%20Roles",
    component: () => import("/tmp/build_68735d90/pages/Company Contact Roles/index.vue")
  },
  {
    name: "Contacts",
    path: "/Contacts",
    component: () => import("/tmp/build_68735d90/pages/Contacts/index.vue")
  },
  {
    name: "Dashboard",
    path: "/Dashboard",
    component: () => import("/tmp/build_68735d90/pages/Dashboard/index.vue")
  },
  {
    name: "Field Sets",
    path: "/Field%20Sets",
    component: () => import("/tmp/build_68735d90/pages/Field Sets/index.vue")
  },
  {
    name: "Groups",
    path: "/Groups",
    component: () => import("/tmp/build_68735d90/pages/Groups/index.vue")
  },
  {
    name: "Home",
    path: "/Home",
    meta: {"middleware":["home-redirect"]},
    component: () => import("/tmp/build_68735d90/pages/Home/index.vue")
  },
  {
    name: "Industries",
    path: "/Industries",
    component: () => import("/tmp/build_68735d90/pages/Industries/index.vue")
  },
  {
    name: "Lead Source Campaigns",
    path: "/Lead%20Source%20Campaigns",
    component: () => import("/tmp/build_68735d90/pages/Lead Source Campaigns/index.vue")
  },
  {
    name: "Lead Source Contacts",
    path: "/Lead%20Source%20Contacts",
    component: () => import("/tmp/build_68735d90/pages/Lead Source Contacts/index.vue")
  },
  {
    name: "Lead Source Events",
    path: "/Lead%20Source%20Events",
    component: () => import("/tmp/build_68735d90/pages/Lead Source Events/index.vue")
  },
  {
    name: "Location Types",
    path: "/Location%20Types",
    component: () => import("/tmp/build_68735d90/pages/Location Types/index.vue")
  },
  {
    name: "Login",
    path: "/Login",
    meta: indexgewO2KykTTt6qoAouWm9rktTHSdPhSI9gE0YS9gls8AMeta || {},
    component: () => import("/tmp/build_68735d90/pages/Login/index.vue")
  },
  {
    name: "Opportunities",
    path: "/Opportunities",
    component: () => import("/tmp/build_68735d90/pages/Opportunities/index.vue")
  },
  {
    name: "Opportunity Stages",
    path: "/Opportunity%20Stages",
    component: () => import("/tmp/build_68735d90/pages/Opportunity Stages/index.vue")
  },
  {
    name: "Orders",
    path: "/Orders",
    component: () => import("/tmp/build_68735d90/pages/Orders/index.vue")
  },
  {
    name: "Payables",
    path: "/Payables",
    component: () => import("/tmp/build_68735d90/pages/Payables/index.vue")
  },
  {
    name: "Persons",
    path: "/Persons",
    component: () => import("/tmp/build_68735d90/pages/Persons/index.vue")
  },
  {
    name: "Product Categories",
    path: "/Product%20Categories",
    component: () => import("/tmp/build_68735d90/pages/Product Categories/index.vue")
  },
  {
    name: "Product Groups",
    path: "/Product%20Groups",
    component: () => import("/tmp/build_68735d90/pages/Product Groups/index.vue")
  },
  {
    name: "Product Subcategories",
    path: "/Product%20Subcategories",
    component: () => import("/tmp/build_68735d90/pages/Product Subcategories/index.vue")
  },
  {
    name: "Projects",
    path: "/Projects",
    component: () => import("/tmp/build_68735d90/pages/Projects/index.vue")
  },
  {
    name: "Receivables",
    path: "/Receivables",
    component: () => import("/tmp/build_68735d90/pages/Receivables/index.vue")
  },
  {
    name: "Service Request Types",
    path: "/Service%20Request%20Types",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_68735d90/pages/Service Request Types/index.vue")
  },
  {
    name: "Service Requests",
    path: "/Service%20Requests",
    component: () => import("/tmp/build_68735d90/pages/Service Requests/index.vue")
  },
  {
    name: "Settings",
    path: "/Settings",
    component: () => import("/tmp/build_68735d90/pages/Settings/index.vue")
  },
  {
    name: "Supplier Contact Roles",
    path: "/Supplier%20Contact%20Roles",
    component: () => import("/tmp/build_68735d90/pages/Supplier Contact Roles/index.vue")
  },
  {
    name: "Suppliers",
    path: "/Suppliers",
    component: () => import("/tmp/build_68735d90/pages/Suppliers/index.vue")
  },
  {
    name: "Team Members",
    path: "/Team%20Members",
    component: () => import("/tmp/build_68735d90/pages/Team Members/index.vue")
  },
  {
    name: "TSD Contact Roles",
    path: "/TSD%20Contact%20Roles",
    component: () => import("/tmp/build_68735d90/pages/TSD Contact Roles/index.vue")
  },
  {
    name: "TSDs",
    path: "/TSDs",
    component: () => import("/tmp/build_68735d90/pages/TSDs/index.vue")
  },
  {
    name: "User",
    path: "/User",
    component: () => import("/tmp/build_68735d90/pages/User/index.vue")
  },
  {
    name: "Users",
    path: "/Users",
    component: () => import("/tmp/build_68735d90/pages/Users/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/build_68735d90/pages/index.vue")
  }
]